import React, { Component, Fragment } from 'react';
import PageHeader from '../../components/page-header';
import './style.scss';
import Button from '../../components/button';
import TextInput from '../../components/text-input';
import { Check } from '@material-ui/icons';
import Axios from 'axios';
import { map } from 'lodash';

export default class AddPet extends Component {
    state = {
        stage: 1,
        DogName: '',
        DogBreed: '',
        DateOfBirthMonth: '',
        DateOfBirthYear: '',
        DogDescription: '',
        errors: {
            DogName: false,
            DogBreed: false,
            DateOfBirthMonth: false,
            DateOfBirthYear: false,
            DogDescription: false,
        },
        complete: false,
        breed_list: []
    }

    handleChange(element) {
        let { value, name } = element;
        let { errors } = this.state;

        if (!value) {
            Object.assign(errors, { [name]: true })
        } else {
            Object.assign(errors, { [name]: false })
        };

        this.setState({
            [name]: value,
            errors
        })
    }

    goToNextStage() {
        this.setState({ stage: this.state.stage + 1 })
    }

    getBreedList() {
        Axios.get('https://dog.ceo/api/breeds/list/all').then(results => {
            this.setState({
                breed_list: map(Object.keys(results.data.message, breed => breed))
            })
        }).catch(err => console.log(err))
    }

    savePet() {
        Axios.post('https://mascota-api.herokuapp.com/pet', {
            "email": localStorage.getItem('user_email'),
            "name": this.state.DogName,
            "pet_type": "dog",
            "breed": this.state.DogBreed,
            "description": this.state.DogDescription,
            "age": 3,
            "weight": 150
        }, { headers: { 'Content-Type': 'application/json', } }).then(data => {
            this.setState({ complete: true })
        }).catch(err => console.log(err))
    }

    componentDidMount() {
        this.getBreedList();
    }


    render() {
        return (
            <div className='add-pet'>
                <PageHeader text='Add pet' history={this.props.history} />

                <div className="add-pet-container">
                    {this.state.stage === 1 && !this.state.complete &&
                        <div className='pet-description'>
                            <label htmlFor="" className='stage-name'>Pet description</label>
                            <TextInput name='DogName' label='Dog name' type='text' value={this.state.DogName} error={this.state.errors.DogName} handleChange={this.handleChange.bind(this)} />

                            <div className="form-group">
                                <label htmlFor="DogBreed">Dog Breed</label>
                                <select className="dog-selector" onChange={e => this.setState({ DogBreed: e.target.value })}>
                                    <option value="Select breed" >Select breed</option>
                                    {
                                        map(this.state.breed_list, breed => (
                                            <option value={breed} key={breed}>{breed}</option>
                                        ))
                                    }
                                </select>

                            </div>

                            {/*  <TextInput name='DogBreed' label='Dog breed' type='text' value={this.state.DogBreed} error={this.state.errors.DogBreed} handleChange={this.handleChange.bind(this)} /> */}
                            <TextInput name='DateOfBirthMonth' label='Date of birth month' type='text' value={this.state.DateOfBirthMonth} error={this.state.errors.DateOfBirthMonth} handleChange={this.handleChange.bind(this)} />
                            <TextInput name='DateOfBirthYear' label='Date of birth year' type='text' value={this.state.DateOfBirthYear} error={this.state.errors.DateOfBirthYear} handleChange={this.handleChange.bind(this)} />
                        </div>
                    }

                    {this.state.stage === 2 && !this.state.complete &&
                        <div className='pet-description'>
                            <label htmlFor="" className='stage-name'>Pet description</label>
                            <div className="form-group">
                                <label htmlFor="DogDescription">Tell borrower about your dog</label>
                                <textarea name='DogDescription' id="DogDescription" onChange={this.handleChange.bind(this)} />
                            </div>
                        </div>
                    }

                    {this.state.stage === 3 && !this.state.complete &&
                        <div className='pet-description'>
                            <div className="avatar">
                                <label htmlFor=""><input type="file" /></label>
                            </div>
                            <label htmlFor="" className='stage-name'>Upload your dog's photo</label>
                            <div style={{ textAlign: 'center', fontSize: 18, marginTop: 15 }}>Your dog will get more attention from borrower if you upload a photo.</div>
                        </div>
                    }

                    {this.state.stage === 4 && !this.state.complete &&
                        <div className='pet-description'>
                            <label htmlFor="" className='stage-name'>My dog loves the following</label>
                            <div className="check-options">
                                <label htmlFor="CheckWalkingExcercise"><input type="checkbox" id='CheckWalkingExcercise' />Walking or Excercise</label>
                                <label htmlFor="CheckPlayTime"><input type="checkbox" id='CheckPlayTime' />Play time</label>
                                <label htmlFor="CheckPetsitters"><input type="checkbox" id='CheckPetsitters' />Pet sitters</label>
                            </div>
                            <label htmlFor="" className='stage-name'>My dog gets along with</label>
                            <div className="check-options">
                                <label htmlFor="CheckCats"><input type="checkbox" id='CheckCats' />Cats</label>
                                <label htmlFor="CheckChildren"><input type="checkbox" id='CheckChildren' />Children</label>
                                <label htmlFor="CheckDogs"><input type="checkbox" id='CheckDogs' />Dogs</label>
                                <label htmlFor="CheckAllPets"><input type="checkbox" id='CheckAllPets' />All pets</label>
                            </div>
                        </div>
                    }

                    {this.state.stage === 5 && !this.state.complete &&
                        <div className='pet-description'>
                            <label htmlFor="" className='stage-name'>My dogs needs a borrower/Pet Sitters/Walker/Exersise</label>
                            <div className="check-options">
                                <label htmlFor="CheckWalkingExcercise"><input type="checkbox" id='CheckWalkingExcercise' />Walking or Excercise</label>
                                <label htmlFor="CheckCheckWeekendsNightTime"><input type="checkbox" id='CheckWeekendsNightTime' />Weekends night-time</label>
                                <label htmlFor="CheckCheckWeekendsDayTime"><input type="checkbox" id='CheckCheckWeekendsDayTime' />Weekends day-time</label>
                                <label htmlFor="CheckOvernight"><input type="checkbox" id='CheckOvernight' />Overnight</label>
                                <label htmlFor="CheckOther"><input type="checkbox" id='CheckOther' />Other</label>
                            </div>
                        </div>
                    }

                    {this.state.complete &&
                        <div className='complete'>
                            <Check fontSize='100px' />
                            <label htmlFor="" className='stage-name'>Well done!</label>
                            You have succefully added a new pet
                        </div>
                    }

                    <div className="controls">
                        {this.state.stage < 5 && !this.state.complete && <Button text='Next' action={this.goToNextStage.bind(this)} />}
                        {this.state.stage === 5 && !this.state.complete && <Button text='Done' action={this.savePet.bind(this)} />}
                        {this.state.complete && <Button text='Complete' action={() => this.props.history.push('/grid-view')} />}
                    </div>
                </div>
            </div>
        );
    }
}
